import { ViewState } from '@devexpress/dx-react-scheduler';
import {AllDayPanel, Appointments,CurrentTimeIndicator,Scheduler,WeekView,} from '@devexpress/dx-react-scheduler-material-ui';
import { alpha, Paper, styled } from '@mui/material';
import classNames from 'clsx';
import { useAppointmentsCalendarContext } from 'components/appointment_calendar_context';
import dayjs from 'dayjs';
import Localization from 'l18n/l18n';
import { useSnackbar } from 'notistack';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import AppointmentCell from './appointment_cell';
import DeleteAppointmentDialog from './calendar_settings/delete_appointment_dialog';
import CalendarSettinsDialog from './calendar_settings/dialog';

var isToday = require('dayjs/plugin/isToday');

dayjs.extend(isToday);

const Calendar = ({timeDuration,appointmentsData,cellTimeDuration}) => {
  
const appointmentContext = useAppointmentsCalendarContext(); 
const { enqueueSnackbar } = useSnackbar();
 
 
const { currentWeek,calendarExeptionStyle} = appointmentContext ;
const [AllAppointment,setAllAppointments] = React.useState(appointmentsData);
const [openDeleteDialog,setOpenDeleteDialog] = React.useState(false);
const [clickedAppointmentInfo,setClickedAppointmentInfo] = React.useState({});

React.useEffect(()=>{
  setAllAppointments(appointmentsData);
},[appointmentsData]);

const handleAppointmentClick = (appointmentInfo,actionType='redirect')=>{
  setClickedAppointmentInfo(appointmentInfo) ;
  if(actionType=='redirect'){
    navigate(`/appointment/${appointmentInfo.appointment_calendar_id}`) ;
    return ;
  }
  if(appointmentInfo.appointment_exception_id == -1){
    enqueueSnackbar(Localization.translate['change_weekend_from_calendar_settings'], {
      variant: 'warning',
      anchorOrigin: { vertical: 'top', horizontal: 'center' },
      preventDuplicate: true,
      autoHideDuration: 2000,
    });
  }else{
    setOpenDeleteDialog(true);
  }
};

const PREFIX = 'appointment-calendar';
let navigate = useNavigate();
  const classes = {
    cell: `${PREFIX}-cell`,
    shaded: `${PREFIX}-shaded`,
    notAvailable: `${PREFIX}-notAvailable`,
    vication: `${PREFIX}-vication`,
    exception: `${PREFIX}-exception`,
    disabledDate: `${PREFIX}-disabledDate`,
    hide: `${PREFIX}-hide`,
  };
  const TimeIndicatorStyled = styled('div')(({ top }) => ({
    [` .timeIndicator-line`]: {
      height: '2px',
      borderTop: `2px #EB2347 solid`,
      width: '100%',
      transform: 'translate(0, -1px)',
      opacity: 0.7,
      right: '-100vw',
    },
    [`& .timeIndicator-circle`]: {
      width: '1rem',
      height: '1rem',
      borderRadius: '50%',
      transform: 'translate(-70%, 50%)',
      background: '#EB2347',
      opacity: 0.7,
    },
    [`& .timeIndicator`]: {
      position: 'absolute',
      zIndex: 1,
      left: 0,
      top,
    },
  }));

  const StyledTableCell = styled(WeekView.TimeTableCell)(({ theme }) => ({
    [`&.${classes.cell}`]: {
      display: appointmentsData.length > 0 ? 'auto' :  'none',
      position: 'relative',
      userSelect: 'none',
      verticalAlign: 'top',
      padding: 0,
      height: '5rem',
      borderLeft: '2px solid',
      borderBottom: '2px solid',
      textAlign:'center',
      alignItems: 'center',
      alignSelf: 'center',
      borderColor:alpha('#000000', 0.05),
      '&:first-of-type': {
        borderLeft: 'none',
      },
      '&:last-child': {
        paddingRight: 0,
      },
      'tr:last-child &': {
        borderBottom: 'none',
      },
      '&:hover': {
        backgroundColor:  alpha(theme.palette.primary.main, 0.15),
      },
      '&:focus': {
        backgroundColor: alpha(theme.palette.primary.main, 0.15),
        outline: 0,
      },
    },
    [`&.${classes.shaded}`]: {
      backgroundColor: alpha('#000000', .02),
    },
    [`&.${classes.notAvailable}`]:{
      lineHeight:'4.5rem',
      color:calendarExeptionStyle.fontColor,
    },
    [`&.${classes.vication}`]:{
      background:calendarExeptionStyle.vicationBackgroundColor,
      borderBottom:0,
    },
    [`&.${classes.exception}`]:{
      background:calendarExeptionStyle.exceptionBackgroundColor,
      borderBottom:0,
    },
    [`&.${classes.hide}`]:{
      display:'none'
    }
  }));
 
 

  const TimeTableCell = React.memo((props) => {

 
    return (
      <StyledTableCell 
        {...props}
        tabIndex={0}
        className={classNames({
          [classes.cell]: true,
          [classes.shaded]: dayjs(props.startDate).isToday() === true ,
          [classes.hide]: appointmentsData.length > 0 ? false : true ,
        })
          }   
     />   
         
    );
  });
  TimeTableCell.displayName = 'TimeTableCell';
  
  const DayScaleCell = (({ formatDate, ...restProps }) => {   
    return (
      <WeekView.DayScaleCell   dir="ltr" {...restProps}   
      className={'DayScaleCell'}
      formatDate={(date, options) =>
        dayjs(date)
        .locale('ar')
        .format(options.weekday ? 'dddd' : 'D\\M\\YYYY')
      } />);
    }
    );
    


  const TimeLabel = (props) => {
   
    return ( <WeekView.TimeScaleLabel dir="ltr"  {...props} 
     style={{ height: '5rem', lineHeight: '7rem',display: appointmentsData.length > 0 ? 'auto' :  'none'}} className="TimeTextLabel"  
     formatDate={(date) => dayjs(date).format('hh:mm a ')}  /> );

  };

  const TimeTickCell = (props) => {
    return ( <WeekView.TimeScaleTickCell    dir="ltr" {...props}  style={{ height: '5rem' }} />);
  };


  const TimeIndicator = ({ top, ...restProps }) => (
    <TimeIndicatorStyled top={top} {...restProps} >
      <div className={'timeIndicator-circle'} />
      <div className={'timeIndicator-line'} />
    </TimeIndicatorStyled>
  );

 const AppointmentComponent  = (props)=>{
    // to redirect to appointment details page when clicking on the appointment inside the calendar
    if(props.data.appointment_exception_id !== null){
      return <Appointments.Appointment  {...props}     onClick={(appointment_data) =>handleAppointmentClick(appointment_data.data,'delete')}   />;
    }
    return <AppointmentCell  {...props}   onClick={(appointment_data) =>handleAppointmentClick(appointment_data.data)} />;
  };
 

const EmptyCellComponent = (props)=>{
  return <WeekView.DayScaleEmptyCell {...props} ><div style={{height:'100%'}}><p style={{textAlign:'center'}}>{Localization.translate['day']}</p></div></WeekView.DayScaleEmptyCell>;
}; 

const TimeLayout = (props) => (
          <WeekView.TimeScaleLayout style={{display: appointmentsData.length > 0 ? 'auto' :  'none',}} {...props} showAllDayTitle={false}  
          allDayTitleComponent={()=><p dir='ltr' style={{paddingRight:'.3rem'}}>{dayjs(props.cellsData[0][0].startDate?props.cellsData[0][0].startDate:0  ).format('hh:mm a')}</p>} 
           />);
const AllDayPanelTitle = (getmessage) =>{
  return <small style={{textAlign:'center',width: '100%',height: '100%',paddingTop: '4.5rem'}}>{Localization.translate['all_day']}</small>;
};

 
 
  return (

    <Paper  sx={{width:'100%'}}>
      <CalendarSettinsDialog open={openDeleteDialog} handleClose={()=>setOpenDeleteDialog(false)} >
          <DeleteAppointmentDialog allAppointments={AllAppointment}  setAppointments={setAllAppointments} clickedAppointmentInfo={clickedAppointmentInfo}/>
        </CalendarSettinsDialog>
    <Scheduler
      locale={Localization.currentLanguage.code}
      data={AllAppointment.filter(appointment=> appointment.patient_info_id != null ||   appointment.appointment_exception_id != null || appointment.allDay == true)}
      adaptivityEnabled={true} 
      crossScrollingEnabled={true}
      showAllDayPanel={false}
      firstDayOfWeek={dayjs(currentWeek).day()}
      >
      <ViewState currentDate={dayjs(currentWeek).format('YYYY-MM-DD')}   />
      <WeekView
        dayScaleCellComponent={DayScaleCell}
        timeTableCellComponent={TimeTableCell}
        timeScaleLabelComponent={TimeLabel}
        timeScaleTickCellComponent={TimeTickCell}
        timeScaleLayoutComponent={TimeLayout}
        dayScaleEmptyCellComponent={EmptyCellComponent}
        startDayHour={Number(timeDuration.startTime)} 
        endDayHour={Number(timeDuration.endTime) === Number(timeDuration.startTime) ? Number(timeDuration.endTime)+1  : Number(timeDuration.endTime)} 
        cellDuration={cellTimeDuration}
        />
        {appointmentsData.length > 0 ? <AllDayPanel titleCellComponent={AllDayPanelTitle}/> : ''}
      <Appointments  appointmentComponent={AppointmentComponent} />
      <CurrentTimeIndicator indicatorComponent={TimeIndicator} />
    </Scheduler>
        </Paper>
     
  );
};

export default (Calendar);
